// Entry point for the build script
import "@hotwired/turbo-rails"
import "@legacy/controllers"
import "trix"
import "@rails/actiontext"
import * as ActiveStorage from "@rails/activestorage"
import Swal from "sweetalert2"
import "@legacy/utils/notifications"

// Make SweetAlert2 globally available
window.Swal = Swal

ActiveStorage.start()
